import React from 'react'
import Vimeo from '@u-wave/react-vimeo';

const Reels = () => {
    return (
        <div className='about-info'>
            <div className="" style={{ width: '100%' }}>
                <Vimeo
                    video="https://vimeo.com/738613188"
                    autoplay
                />
            </div>

        </div>
    )
}

export default Reels